var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset-complete-pane"},[_c('password-reset-complete-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }